import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { delay: Number };

  connect() {
    const delay = this.delayValue || 3000;
    setTimeout(() => {
      this.element.style.display = "none";
    }, delay);
  }
}
